import { map } from 'rxjs/operators';
import { Injector } from '@angular/core';

import { SgEntityFetchAdapter } from '../components/entity-select-auto-complete';
import { BroadcastApi, BroadcastTransmissionApiClient } from '@sg/api/broadcast-api';

declare module '../components/entity-select-auto-complete/entity-select-fetch-store.service' {
  export interface SgEntitySelectEntityFetchMap {
    Transmission: {
      entity: BroadcastApi.Transmission;
      query: BroadcastApi.TransmissionSearchRequestDto;
    };
  }
}

export class TransmissionApiToEntityFetcherLink implements SgEntityFetchAdapter<'Transmission'> {
  readonly key: 'Transmission' = 'Transmission';
  readonly metadata: {
    idField: keyof BroadcastApi.Transmission;
    labelField: keyof BroadcastApi.Transmission;
    queryField?: { field: keyof BroadcastApi.TransmissionSearchRequestDto; isArray?: boolean };
  } = {
    idField: 'id',
    labelField: 'name',
    queryField: { field: 'name' },
  };

  private readonly transmissionsApi: BroadcastTransmissionApiClient;

  constructor(injector: Injector) {
    this.transmissionsApi = injector.get(BroadcastTransmissionApiClient);
  }

  getEntity(id: string) {
    return this.transmissionsApi.transmissionControllerGetTransmissionById(id, { observe: 'body' });
  }

  findEntities(query?: BroadcastApi.TransmissionSearchRequestDto, pageNumber?: number) {
    const body: BroadcastApi.TransmissionSearchRequestDto = {};

    if (query) {
      Object.assign(body, query);
    }

    return this.transmissionsApi
      .transmissionControllerSearchTransmissions(
        { body, pageSize: 10, pageNumber: pageNumber ?? 1 },
        { observe: 'body' }
      )
      .pipe(
        map((result) => {
          return {
            data: result.rows ? result.rows : [],
            infiniteScrollInfo: { currentPage: result.paging.pageNumber, totalPages: result.paging.totalPages },
          };
        })
      );
  }
}
